import { IItso } from "@types";
import { BaseAPI } from "@utils";

class ItsoApi extends BaseAPI<IItso> {}

export const itsoApi = new ItsoApi("/api/v1/itso");
